import { useColorTheme } from "../hooks/use-color-theme.js";
import { Fragment, jsx } from "react/jsx-runtime";
//#region src/color-theme/color-theme.tsx
/**
* Overrides the token theming for its children.
*
* @see https://fpl.figma.design/components/color-theme/
*/
function ColorTheme({ children, mode, brand, enhancedContrast }) {
	const theme = useColorTheme({
		mode,
		brand,
		enhancedContrast
	});
	if (!mode && !brand && enhancedContrast == null) return /* @__PURE__ */ jsx(Fragment, { children });
	return /* @__PURE__ */ jsx(theme.Context, {
		value: theme,
		children: /* @__PURE__ */ jsx("div", {
			...theme.dataAttributes,
			style: { display: "contents" },
			children
		})
	});
}
//#endregion
export { ColorTheme };

//# sourceMappingURL=color-theme.js.map